import {Col, Divider, DividerProps} from 'antd';
import classnames from 'classnames';
import useCommon from '@utils/hooks/common';
import styles from './styles';

interface CustomDividerProps extends DividerProps {}

const CustomDivider = (props: CustomDividerProps) => {
  const {classes, t} = useCommon({
    withTranslation: null,
    withStyles: styles,
  });

  const {children, className, ...rest} = props;

  return (
    <Divider className={classnames(classes.divider, className)} {...rest}>
      {children}
    </Divider>
  );
};

export default CustomDivider;
